export const noToken = ['/i18n/lang_code']